export default __webpack_public_path__ + "static/media/Snd_ClowerP.d82a385a.mp3";